export default {
  title: 'The page was lost',
  subtitle: `The page you are looking for is not in the system.
   Please check the address`,
  text: 'Try again to enter the page address or find it through the main page',
};
